import React from 'react'
import ActiveVehicle from './../BOTProductAndServicesQuoteNew/components/ActiveVehicle'

const BOTYourVehicle = ({
  ...props
}) => <ActiveVehicle { ...props } />

export default BOTYourVehicle
